import Column, { ColumnProps } from './Column';

export default Column;
export type { ColumnProps };